import { InjectionToken } from '@angular/core';

/**
 * Interface for the query API configuration.
 */
export interface QueryServiceConfig {
  url: string;
}

/**
 * This injection token can be used to inject the query API configuration.
 */
export const QUERY_CONFIG = new InjectionToken<QueryServiceConfig>('QueryServiceConfig');
